import React from "react";
import { FieldRenderProps } from "react-final-form";

const TextAreaInput: React.FC<FieldRenderProps<any, HTMLElement>> = ({
  input,
  width,
  rows,
  placeholder,
  className,
  readOnly,
  customOnBlur,
  meta: { touched, error },
}) => {
  return (
    <textarea
      {...input}
      rows={rows}
      placeholder={placeholder}
      className={className}
      readOnly={readOnly}
      onBlur={(e) => {
        if (customOnBlur) customOnBlur(e);
      }}
    />
  );
};

export default TextAreaInput;
